var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallCardShadow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 353,
    height: 202,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_0",
    gradientUnits: "userSpaceOnUse",
    x1: 176.5,
    y1: -1.9973606e-14,
    x2: 176.5,
    y2: 202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0D0014",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59556657,
    stopColor: "#0D0014",
    stopOpacity: 0.80000001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99611372,
    stopColor: "#0D0014",
    stopOpacity: 0.90196079
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0014"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_0)",
    d: "M0 0L353 0L353 196C353 199.31371 350.31372 202 347 202L6 202C2.6862915 202 2.0290612e-16 199.31371 0 196L0 0L0 0Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCardShadow);
export default __webpack_public_path__ + "static/media/smallCardShadow.c71422c75b5218e582896b3d37106843.svg";
export { ForwardRef as ReactComponent };